import type { LinkProps } from '@components/Link'
import { Link } from '@components/Link'
import { LANGUAGE_CODES } from '@constants/countryDetails'
import { APP_FEATURES } from '@constants/features'
import { arrayIncludes } from '@helpers/arrayIncludes'
import { getCountryLanguageFromLocale } from '@helpers/getCountryLanguageFromLocale'
import { useGetLocale } from '@hooks/useGetLocale'

type LinkForAppFeaturesProps = Omit<LinkProps, 'url'> & {
  type: keyof typeof APP_FEATURES
  slug: string
}

export const LinkForAppFeatures = ({
  slug,
  type,
  children,
  ...rest
}: LinkForAppFeaturesProps) => {
  const locale = useGetLocale()
  const { language: languageString } = getCountryLanguageFromLocale(locale)
  const language = arrayIncludes(LANGUAGE_CODES, languageString)
    ? languageString
    : null

  if (!locale) return null

  const prefix = language ? APP_FEATURES[type].prefix[language] : null

  const fullUrl = language && slug ? `/${locale}${prefix}/${slug}` : null

  if (!fullUrl) return null

  return (
    <Link url={fullUrl} {...rest}>
      {children}
    </Link>
  )
}
